// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M17.5,15c-0.8,0-1.5,0.4-2,1l-7.6-3.4C8,12.4,8,12.2,8,12c0-0.2,0-0.4-0.1-0.6L15.5,8c0.8,1.1,2.4,1.3,3.5,0.5
		s1.3-2.4,0.5-3.5S17.1,3.7,16,4.5c-0.6,0.5-1,1.2-1,2c0,0.2,0,0.4,0.1,0.6l-7.6,3.4C6.7,9.4,5.1,9.2,4,10s-1.3,2.4-0.5,3.5
		S5.9,14.8,7,14c0.2-0.1,0.4-0.3,0.5-0.5l7.6,3.4C15,17.1,15,17.3,15,17.5c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5S18.9,15,17.5,15z
		 M17.5,5C18.3,5,19,5.7,19,6.5S18.3,8,17.5,8S16,7.3,16,6.5S16.7,5,17.5,5z M5.5,13.5C4.7,13.5,4,12.8,4,12s0.7-1.5,1.5-1.5
		S7,11.2,7,12S6.3,13.5,5.5,13.5z M17.5,19c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5S18.3,19,17.5,19z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-share-DgOA3Wso.js.map
